import { render, staticRenderFns } from "./EditorVariables.vue?vue&type=template&id=ec922004&scoped=true&"
import script from "./EditorVariables.vue?vue&type=script&lang=js&"
export * from "./EditorVariables.vue?vue&type=script&lang=js&"
import style0 from "./EditorVariables.vue?vue&type=style&index=0&id=ec922004&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec922004",
  null
  
)

export default component.exports